import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ti-interview.css';
import { INTERVIEW_HTML } from './tripink/interviewMarkup';
import { initInterview } from './tripink/interviewInit';
import { mountShell } from './tripink/shell';

/* Artist profile interview (12 questions by video, voice or text + portfolio form).
   ZIGGEO_APP_TOKEN and SUBMIT_WEBHOOK_URL are intentionally empty (top of tripink/interviewInit.ts):
   recordings stay in the browser and Submit downloads the answers as a file until those are set. */
export function ArtistInterview() {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const navRef = useRef(navigate);
  navRef.current = navigate;
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    root.innerHTML = INTERVIEW_HTML;
    const undoShell = mountShell(root, to => navRef.current(to), {
      title: 'Trip Ink Tattoo | Artist Interview',
      rootFontSize: 'clamp(16px, 0.9vw + 11px, 24px)',
      background: '#0b0b0b'
    });
    const cleanup = initInterview(root);
    return () => {
      cleanup();
      undoShell();
      root.innerHTML = '';
    };
  }, []);
  return <div ref={ref} className="ti-iv" data-id="element-234" data-mp="1fmuh5ft3z0ij" />;
}